import React from 'react';
import '@/styles/matrix-logo.css';

interface MatrixLogoProps extends React.SVGProps<SVGSVGElement> {
  direction?: 'left' | 'right';
  ringColor?: string;
}

export function MatrixLogo({ className, direction = 'left', ringColor, ...props }: MatrixLogoProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} matrix-logo-${direction}`}
      {...props}
    >
      <g transform="scale(0.85) translate(1.8, 1.8)">
        {/* Outer Square - Theme Color */}
        <rect className="outer-square" x="2" y="2" width="20" height="20" rx="4" stroke="currentColor" strokeWidth="1.5" />

        {/* Inner Ring - Theme Color */}
        <circle cx="12" cy="12" r="8" strokeWidth="1.5" opacity="0.7" style={{ stroke: ringColor || "currentColor" }} />

        {/* Contract Symbol - Theme Color */}
        <g transform="scale(0.4) translate(18, 18)">
          <path d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2z" 
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M14 2v4a2 2 0 0 0 2 2h4" 
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line x1="8" y1="13" x2="16" y2="13" 
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line x1="8" y1="17" x2="16" y2="17" 
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line x1="8" y1="9" x2="16" y2="9" 
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
